import { TrackerService } from '@app/shared/services/tracker.service';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { Observable } from 'rxjs';

export interface LinkData {
  links: Link[];
  linkSectionTitle: string;
}

export interface Link {
  title: string;
  url: string;
}

@Injectable({
  providedIn: 'root',
})
export class OrgLinksService {
  constructor(
    private http: NgxHttpClient,
    private trackerService: TrackerService
  ) {}

  public getOrganizationLinks(
    orgId: number,
    forceRefresh = false
  ): Observable<LinkData> {
    return this.http.get<LinkData>('/organizations/getorganizationlinks', {
      params: {
        organizationId: orgId,
        v: forceRefresh ? Date.now() : undefined,
      },
    });
  }

  public updateOrganizationLinks(
    orgId: number,
    organizationLinksConfig: LinkData
  ) {
    return this.http
      .post('/organizations/updateorganizationlinks', {
        orgId,
        organizationLinksConfig,
      })
      .pipe(
        tap(() => {
          this.trackerService.trackEventData({
            action: 'Org Settings Updated',
            properties: {
              ActionLocation: 'Org Settings - Links',
              OrganizationId: orgId,
            },
          });
        })
      );
  }
}
